export default "__VITE_ASSET__BHOkoOEU__"